"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mapLocation;

function mapLocation(location) {
  return {
    asName: location.as_name,
    asn: location.asn,
    connectionType: location.connection_type,
    countryCode: location.country_code,
    countryCode2: location.country_code2,
    countryName: location.country_name,
    dma: location.dma,
    ipAddress: location.ip_address || '',
    networkAllowed: location.network_allowed,
    postalCode: location.postal,
    regionCode: location.region_code || ''
  };
}